import axios from 'axios'

axios.defaults.timeout = 5000;                        //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';        //配置请求头
// axios.defaults.baseURL = 'http://proxy.jiankanghao.net:50070/api/v1/';   //配置接口地址
axios.defaults.baseURL = 'http://192.168.0.9/kx_library/public/api/v1/';  
// axios.defaults.baseURL = 'https://api.kanguji.com/api/v1/';  
export default axios


// WEBPACK FOOTER //
// ./src/assets/api/http.js